<div class="flex flex-col items-center gap-[53px] md:gap-[79px]">
  <h2 class="max-w-[275px] text-center text-2xl font-bold leading-[30px] md:max-w-none">{{ question.title }}</h2>

  <div class="flex w-[332px] max-w-full flex-col items-center gap-[23px]">
    <!-- Scroller -->
    <div
      class="relative h-[116px] w-full touch-none select-none outline-none"
      tabindex="0"
      role="slider"
      [attr.aria-valuemin]="question.min"
      [attr.aria-valuemax]="question.max"
      [attr.aria-valuenow]="value"
      [attr.aria-valuetext]="value + ' ' + question.unit"
      (keydown.arrowleft)="step(-1); $event.preventDefault()"
      (keydown.arrowright)="step(1); $event.preventDefault()"
      (wheel)="onWheel($event)"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp()"
      (pointercancel)="onPointerUp()"
    >
      <ng-container *ngFor="let slot of slots">
        <button
          *ngIf="neighbour(slot.offset) !== null"
          type="button"
          tabindex="-1"
          class="absolute left-1/2 top-[52px] w-12 -translate-x-1/2 -translate-y-1/2 text-[26px] font-bold leading-none"
          [ngClass]="slot.offset === -1 || slot.offset === 1 ? 'text-[#4C4F53]' : 'text-[#BEBDC1]'"
          [style.margin-left.px]="slot.x"
          (click)="select(neighbour(slot.offset))"
        >{{ neighbour(slot.offset) }}</button>
      </ng-container>

      <div class="absolute left-1/2 top-0 h-[116px] w-[116px] -translate-x-1/2">
        <img src="assets/profile-onboarding/picker-circle.svg" width="116" height="116" alt="" />
        <span class="absolute inset-x-0 top-[31px] text-center text-[50px] font-bold leading-none">{{ value }}</span>
        <span class="absolute inset-x-0 top-[76px] text-center text-xs">{{ question.unit }}</span>
      </div>
    </div>

    <p *ngIf="question.hint" class="w-[284px] max-w-full text-center text-base italic leading-6">{{ question.hint }}</p>
  </div>

  <div class="flex w-full flex-col gap-6">
    <button
      type="button"
      class="flex h-[55px] w-full items-center justify-center rounded-full bg-black px-9 text-[15px] font-bold uppercase leading-5 tracking-[1.5px] text-white"
      (click)="answer.emit(value)"
    >Next</button>
    <button
      *ngIf="question.notSureValue !== undefined"
      type="button"
      class="flex h-[55px] w-full items-center justify-center rounded-full border border-black bg-white px-9 text-[15px] font-bold uppercase leading-5 tracking-[1.5px]"
      (click)="answer.emit(question.notSureValue)"
    >Not sure</button>
  </div>
</div>
